// extracted by mini-css-extract-plugin
export default {"loader-container":"LoadingPage_loader-container__6MZVt","spinner":"LoadingPage_spinner__uLsI3","spin-anim":"LoadingPage_spin-anim__vocPg"};